/**
 * @Description: index
 * @author: 蔡锦欣
 * @date 2022/1/26 12:30 PM
 */
/* eslint-disable no-param-reassign,  no-console */
import axios from 'axios';
import {baseUrl} from './url';
const service = axios.create({
    // baseURL: 'http://localhost:3009/api/', // 阿里云 api的base_url
    // baseURL: 'http://localhost:4000/api/', //腾讯云 api的base_url
    baseURL: `${baseUrl}`, //本地 api的base_url
    timeout: 100000 // 请求超时时间
});

/** **** request拦截器==>对请求参数做处理 ***** */
service.interceptors.request.use(
    async config => {
        config.headers.token = sessionStorage.getItem('token');
        config.headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`; // 让每个请求携带自定义token 请根据实际情况自行修改
        config.user = '';
        return config;
    },
    error => {
        // 请求错误处理
        Promise.reject(error);
    }
);

// respone拦截器
service.interceptors.response.use(
    response => {
        console.log('respone拦截器', response);
        return response.data;
    },
    error => {
        // console.log('axios error:', error);
        if (error.response && error.response.status === 401) {
            const { response } = error;
            // console.log('status', response.status);
            // console.log('data', response.data);
            return response.data;
        } else {
            return Promise.reject(error);
        }
    }
);

export default service;
